import { PayloadAction } from '@reduxjs/toolkit';

import { DesignState } from 'editor/src/store/design/types';

const setAutoApplyLayoutSchemaNamesReducer = (state: DesignState, action: PayloadAction<string[] | undefined>) => {
  state.autoApplyLayoutSchemaNames = action.payload;
};

export default setAutoApplyLayoutSchemaNamesReducer;
